export default __webpack_public_path__ + "static/media/fruit-1024w.0ce8e48c.png";